import {SisName} from 'util/SisName';
import {AppName} from 'util/AppName';
import {PlanTemplateSisNameUrl} from 'appmodule/planTemplate/api/PlanTemplateAPI'

export const SisNameUrl: { [sisName in SisName]?: string } = {
	[SisName.Booking]: '../json/booking',
	[SisName.Persurl]: '../json/persurl',
	[SisName.PlanTempl]: PlanTemplateSisNameUrl,
}
Object.freeze(SisNameUrl);

export const SisNameAppSpecificUrl: { [app in AppName]?: { [sisName in SisName]?: string } } = {
	[AppName.terminal]: {
		[SisName.Booking]: '../json/terminalPageController/evoTerminalBooking',
	},
}
